import { Component, OnDestroy, OnInit } from '@angular/core';
import { LanguageTranslateService } from 'src/app/_services/language-translate.service';
import { UtilServiceService } from 'src/app/_services/utilService/util-service.service';
import { SubscriptionUtil } from 'src/app/_utilities/subscription';
import { ActivatedRoute, Router } from '@angular/router';
import { BreadcrumbService } from 'src/app/_services/breadcrumb.service';

@Component({
    selector: 'app-options-requisition-options',
    templateUrl: './options-requisition-options.component.html',
    styleUrls: ['./options-requisition-options.component.scss'],
    standalone: false
})
export class OptionsRequisitionOptionsComponent extends SubscriptionUtil implements OnInit, OnDestroy {
  translate: any;
  requestType: string = 'none';
  tempRequestType: any;
  requestAssetType: string = 'none';
  mode: any;
  parentType: any;
  redirectUrl: string='dashboard/inventory/global-requisition';

  constructor(
    private util: UtilServiceService,
    private languageTranslateService: LanguageTranslateService,
    private router: Router,
    private route: ActivatedRoute,
    private breadcrumb: BreadcrumbService
  ) { 
    super();
    if (this.route.snapshot.data["mode"]) {
      this.mode = this.route.snapshot.data["mode"];
    }
  }

  ngOnInit(): void {
    this.parentType = this.route.snapshot.data['parentType'] || 'none';
    this.requestType = this.route.snapshot.data['requestType'] || 'none';
    if(this.parentType == 'consignment'){
      this.redirectUrl= 'dashboard/inventory/global-consignment'
    }

    this.getLanguageData();
  }
  getLanguageData() {
    this.push(
      this.languageTranslateService.wordSrc$.subscribe((data) => {
        if (Object.keys(data).length != 0) {
          this.translate = data;
          this.loadBreadCrum();
         
        }
      })
    );
  }
  loadBreadCrum() {
    console.log(this.mode, "===mode", this.parentType)
    var labels = this.parentType == 'consignment' ? this.translate?.consignment.label.plural : this.translate?.requisition.label.plural;
    var newLabel = this.parentType == 'consignment' ? this.translate?.consignment.label.singular : this.translate?.requisition.label.singular;
    var data = [
      { label: labels, routerLink: [this.redirectUrl+"/all"] },
      { label: this.mode == "add" ?  this.translate?.general.buttons.new.singular + " " +newLabel :  this.translate?.general.buttons.edit.singular + " " +newLabel, routerLink: [this.redirectUrl+"/selection"] },
      { label: this.requestType == 'asset' ? this.translate?.asset.label.singular : this.translate?.product.label.singular },
      
    ];
  
  this.breadcrumb.setItems(data);
  }
  goBack(){
   
      this.router.navigate([this.redirectUrl+"/selection"]);
    
   
  }
  cancel() {
 this.router.navigate([this.redirectUrl+"/all"]);
  }
  
  onSelectOptionTypeChange(type: any) {
    console.log('Selected Type:', type);

    if(type == 'specificAssets' ){
      this.router.navigate([this.redirectUrl+'/selectionAsset/specificAssets']);
    }else if(type == 'assetType' ){
      this.router.navigate([this.redirectUrl+'/selectionAsset/assetType']);
    }else if(type == 'requestFromBin' ){
      this.router.navigate([this.redirectUrl+'/selectionSparePart/requestFromBin']);
    }else if(type == 'selectFromBin' ){
      this.router.navigate([this.redirectUrl+'/selectionSparePart/selectFromBin']);
    }else if(type == 'custom' ){
      this.router.navigate([this.redirectUrl+'/custom']);
    }
  }


}
